import axios from 'axios';
import { API_BASE_URL } from '../config/apiConfig';
import api from './api';
import iq_api_v2 from './iqApiV2';
import qs from "qs";


export const saveCheckoutClientInfo = (checkout_client_id, checkout_client_name, checkout_client_ks_company_code, checkout_client_ks_company_name ) => {
  localStorage.setItem('checkout_client_id', checkout_client_id);
  localStorage.setItem('checkout_client_name', checkout_client_name);
  localStorage.setItem('checkout_client_ks_company_code', checkout_client_ks_company_code);
  localStorage.setItem('checkout_client_ks_company_name', checkout_client_ks_company_name);
};

export const getCheckoutClientId  = () => {
  return localStorage.getItem('checkout_client_id') || '';
}

export const getCheckoutClientName  = () => {
  return localStorage.getItem('checkout_client_name') || '';
}

export const getCheckoutClientKSCompanyCode  = () => {
  return localStorage.getItem('checkout_client_ks_company_code') || '';
}

export const getCheckoutClientKSCompanyName  = () => {
  return localStorage.getItem('checkout_client_ks_company_name') || '';
}

export const getCheckoutClientInfo  = () => {
  return { 
    'checkoutClientId' : getCheckoutClientId(), 
    'checkoutClientName' : getCheckoutClientName(),
    'checkoutClientKsCompanyCode' : getCheckoutClientKSCompanyCode(),
    'checkoutClientKsCompanyName' : getCheckoutClientKSCompanyName(),
  } 
}

export const removeCheckoutClientInfo = () => {
  localStorage.removeItem('checkout_client_id');
  localStorage.removeItem('checkout_client_name');
  localStorage.removeItem('checkout_client_ks_company_code');
  localStorage.removeItem('checkout_client_ks_company_name');
};


// Function to save tokens to localStorage
export const saveTokens = (accessToken, refreshToken) => {
  localStorage.setItem('access_token', accessToken);
  localStorage.setItem('refresh_token', refreshToken);
};

// Function to get access token from localStorage
export const getAccessToken = () => {
  return localStorage.getItem('access_token');
};

// Function to get refresh token from localStorage
export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token');
};

// Function to remove tokens from localStorage
export const removeTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.clear();
  sessionStorage.clear();
};

const login = async (email, password, userStat) => {
    localStorage.clear();
    sessionStorage.clear();
    try {
      const response = await api.post('/auth/login', { email, password, userStat });
      
      const { access_token, refresh_token } = response.data.result;
      
      if(access_token && refresh_token){
        saveTokens(access_token, refresh_token);
        return true;
      }else{
        return false;
      }

    } catch (error) {
      throw error.response ? error.response.data : new Error('Unable to connect to the server. Please check your internet connection and try again."');
    }
};
  
export { login };

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const refreshAccessToken = async () => {
  try {

    const api_refresh = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Intercept request to add authorization token
    api_refresh.interceptors.request.use(
      (config) => {
        // Get the refresh token from your storage (e.g., localStorage, cookies, etc.)
        const refreshToken = getRefreshToken();
        if (refreshToken) {
          config.headers.Authorization = `Bearer ${refreshToken}`;
        }
        // console.log('Request:', config); // Log the request for debugging
        return config;
      },
      (error) => Promise.reject(error)
    );

    const response = await api_refresh.post('/auth/refresh');
    const { access_token } = response.data.result;

    if (access_token) {

      localStorage.setItem('access_token', access_token);

      return access_token;
    } else {
      throw new Error('Access token not returned.');
    }
  } catch (error) {
    console.error('Error refreshing access token:', error);
    throw error; // Rethrow to be caught in the interceptor
  }
};

export { refreshAccessToken };

const forgotpassword = async (email) => {
  try {
    const response = await api.post('/users/forgot_password', { email });
    //console.log(response);
    //const response = '{"result": { "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcxOTk5NzI5MywianRpIjoiZDFlMDNlMDctNzdkMS00NDk2LWIxOWItOTQ4YTI5YzdiZTYzIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6eyJpZCI6IjY2N2U2NTk3ZDMwMGJmNzgwMGUxZjg2YyIsImVtYWlsIjoibXVrZXNoLnBhdGlsQG1hcmtldHNhbmRtYXJrZXRzLmNvbSIsImZpcnN0bmFtZSI6Ik11a2VzaCIsImxhc3RuYW1lIjoiUGF0aWwiLCJjb21wYW55X25hbWUiOiJNbm0gVGVzdCIsImNvbXBhbnlfaWQiOiI2NjgzYTM0MzA1ZDZjOTUzMzUzNmY3YWQiLCJyb2xlIjoiMjUifSwibmJmIjoxNzE5OTk3MjkzLCJjc3JmIjoiYTFiODZmNWYtM2NkYS00ODM5LWFiNGItYWFjNjczZjQzYjMzIiwiZXhwIjoxNzIwMDAwODkzfQ.mBbtYZD62bznK09M91vvdy78qY0yhxh4gPkhhMbYLzQ","refresh_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcxOTk5NzI5MywianRpIjoiNmQzMjk0M2QtMzBjMy00NzhlLTlkODctOTU0NDgyY2M3MmE4IiwidHlwZSI6InJlZnJlc2giLCJzdWIiOnsiaWQiOiI2NjdlNjU5N2QzMDBiZjc4MDBlMWY4NmMiLCJlbWFpbCI6Im11a2VzaC5wYXRpbEBtYXJrZXRzYW5kbWFya2V0cy5jb20iLCJmaXJzdG5hbWUiOiJNdWtlc2giLCJsYXN0bmFtZSI6IlBhdGlsIiwiY29tcGFueV9uYW1lIjoiTW5tIFRlc3QiLCJjb21wYW55X2lkIjoiNjY4M2EzNDMwNWQ2Yzk1MzM1MzZmN2FkIiwicm9sZSI6IjI1In0sIm5iZiI6MTcxOTk5NzI5MywiY3NyZiI6ImRmOTY4NDY2LWE2MGItNDYwMC1hOWNmLTAzZTBlMmM2MmQzMSIsImV4cCI6MTcyMDA4MzY5M30.8hzunC4jLjnt_6k8dxJ4y8dF8XpXlfO1OJHEODUZ5Zg"},"status": 200 }';
    //const response = '{"message":"Please enter Login details"}';
    //const { access_token, refresh_token } = response.data.result; 
    
    //const status = response.data.status;
    //saveTokens(access_token, refresh_token);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Unable to connect to the server. Please check your internet connection and try again."');
  }
};

export { forgotpassword };

const asknewsquestion = async (requestData) => {
  try {
    const response = await api.post('/analyst_request/submit_news_request?v=1', requestData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer YOUR_ACCESS_TOKEN' // replace with your actual token
      }
    });
    return response.data;
  
  } catch (error) {
    throw error.response ? error.response.data : new Error('Unable to connect to the server. Please check your internet connection and try again."');
  }
};

export { asknewsquestion };

const unsubscribenewsletter = async (requestData) => {
  try {
    const response = await api.post('/analyst_request/unsubscribe_news_letter?v=1', requestData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer YOUR_ACCESS_TOKEN' // replace with your actual token
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Unable to connect to the server. Please check your internet connection and try again."');
  }
};

export { unsubscribenewsletter };

const newsresponse = async (requestData) => {
  try {
    const response = await api.post('/analyst_request/like_newsletter?v=1', requestData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer YOUR_ACCESS_TOKEN' // replace with your actual token
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Unable to connect to the server. Please check your internet connection and try again."');
  }
};

export { newsresponse };

const resetpassword = async (encoded_data, password) => {
  try {
    const email = localStorage.getItem('forgotemail');
    const response = await api.post('/users/reset_password', { encoded_data, email, password });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Unable to connect to the server. Please check your internet connection and try again."');
  }
};
export { resetpassword };

const checkpasstoken = async (encoded_data) => {
  try {
    const response = await api.post('/users/check_password_reset_key', { encoded_data });
      //console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Invalid URL');
  }
};
export { checkpasstoken };

const otp = async (email, password) => {
  try {
    const response = await api.post('/auth/login', { email, password });
    
    const { access_token, refresh_token } = response.data.result;
    
    saveTokens(access_token, refresh_token);

    return response.data.result;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Unable to connect to the server. Please check your internet connection and try again."');
  }
};

export { otp };

// Function to fetch user details using access token
export const fetchUserDetails = async () => {

  try {

    const accessToken = getAccessToken();
    if(accessToken == null){
      return false;
    }

    if (!accessToken) {
      throw new Error('Access token not found');
    }

    const response = await api.get('/me/');

    return response.data.result.user_info; // Assuming response.data.user contains firstname, lastname
  } catch (error) {

    console.log(error)

    console.error('Fetch user details error:', error);
    throw error;
  }
};

export const updateUserAgreement = async () => {

  try {

    const accessToken = getAccessToken();
    if(accessToken == null){
      return false;
    }

    if (!accessToken) {
      throw new Error('Access token not found');
    }

    const response = await api.put('/me/agreeToTerms');
    return response;

  } catch (error) {

    console.log(error)

    console.error('Fetch user details error:', error);
    throw error;
  }
};

// Function to fetch account info
export const fetchAccountInfo = async (id) => {

  try {

    const response = await api.get('/account/get_account_info?id=' + id);

    return response.data.result.user_info;
  } catch (error) {
    console.log(error)
    console.error('Fetch user details error:', error);
    throw error;
  }
};

const switchUserRole = async (role) => {
  try {
    const response = await api.post('/users/switch_user', { role });
    const { access_token, refresh_token } = response.data.result;
    saveTokens(access_token, refresh_token);
    return response.data.result;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Unable to connect to the server. Please check your internet connection and try again."');
  }
};


export async function fetchGlobalAccounts({ start, rows, q, fq }) {
  try {
    const resp = await iq_api_v2.get("company/get_results", {
      params: { start, rows, q, fq },
      paramsSerializer: (params) =>
        qs.stringify(params, {
          indices: false,   // prevents fq[]= → fq repeated
          encode: true,     // ✅ this ensures proper URL encoding
        }),
    });
    return resp;
  } catch (error) {
    console.error("fetchGlobalAccounts error", error);
  }
}


export async function fetchGlobalAccountsIndustriesDropDown(facetField = "industries") {
  try {
    const resp = await iq_api_v2.get(
      `company/get_results?facet=true&facet.field=${facetField}&facet.limit=-1&rows=0`
    );

    return resp?.data?.facet_counts?.facet_fields?.[facetField];
  } catch (error) {
    console.error("fetchGlobalAccounts error", error);
  }
}




export { switchUserRole };